import { EmpresaService } from 'app/modules/company-view/services/empresa.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { HeaderService } from '../../services/header-service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { CompanyTreeViewService } from './service/company-tree-view.service';
import { TreeViewOrigin } from 'app/modules/common/enums/common-enums';
import Utils from 'app/Utils';

declare var $: any;

@Component({
    selector: 'app-tree-view-new',
    templateUrl: './tree-view.component.html',
    styleUrls: ['./tree-view.component.scss'],
    standalone: false
})
export class TreeViewComponentNew implements OnInit {

    public treeIcon = 'expand_more';

    private currentUser: any;
    private currentCompanyId = 0;

    private isTreeInitialized = false;
    private companyData: any[];

    public selectedCompany: string;
    public searchString: string;

    // keys
    private readonly KEY_COMPANY_LIST = "companiesForTreeView";

    @Input() public origin: number;
    @Input() public companyId: number;
    @Input() public companyName: string;
    @Output() public companyNode = new EventEmitter();

    @ViewChild(MatMenuTrigger) companyTreeMenu: MatMenuTrigger;

    constructor(
        public headerService: HeaderService,
        private empresaTreeViewService: EmpresaTreeViewService,
        private companyTreeService: CompanyTreeViewService,
        private empresaService: EmpresaService,) {
        
    }

    ngOnInit(): void {
        this.companyTreeService.origin = this.origin;

        const id = this.companyId
        this.empresaService.GetEmpresaById(id).subscribe(res=>{
            this.companyName=res.result.nombre;
            const name = this.companyName;
            this.initSelectedValues(id, name);

            this.companyTreeService.companySelected.subscribe(company => {
                if (company && this.origin === TreeViewOrigin.Other) {
                    this.initSelectedValues(company.Id, company.Name);
                }
            });
        })
        
    }

    private initSelectedValues(companyId: number, companyName: string): void {
        this.currentCompanyId = companyId;

        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (this.currentUser) {

            // get companies from storage
            const companyList = JSON.parse(Utils.decrypt(localStorage.getItem(this.KEY_COMPANY_LIST)));
            if (companyList) {
                this.setCompanyList(companyList);
                this.loadCompanyListFromAPI();
            } else {
                this.loadCompanyListFromAPI();
            }

        }
        if (companyName) {
            this.selectedCompany = String(companyName);
        }
    }

    triggerTreeInit(): void {
        if (!this.isTreeInitialized && this.currentUser) {
            this.initCompanyTree();
        }
        this.treeIcon = 'expand_less';
        this.isTreeInitialized = true;
    }

    loadCompanyListFromAPI(): void {

        if (this.companyTreeService.origin === TreeViewOrigin.Header) {
            this.headerService.isLoading = true;
        }

        this.empresaTreeViewService.getEmpresaTreeView().subscribe((res: any) => {
            if (res.code === 0) {

                localStorage.setItem(this.KEY_COMPANY_LIST, Utils.encrypt(JSON.stringify(res.result)));
                this.setCompanyList(res.result);

            } else if (res.code === 1) {
                return null;
            }

            if (this.companyTreeService.origin === TreeViewOrigin.Header) {
                this.headerService.isLoading = false;
            }

        });
    }

    setCompanyList(companyList: any) {

        this.companyData = companyList;

        // TO PREVENT FROM REFRESHING THE SELECTED COMPANY ON PAGE REFRESH
        if ((isNaN(this.currentCompanyId) || this.currentCompanyId === 0)
            && this.origin === TreeViewOrigin.Header) {
            const firstCompany = this.companyData[0];
            this.setCompanyStorageData(firstCompany);

            // The following method emmits the company change
            // Calling this ensures that the counts are loaded on 
            this.empresaTreeViewService.getEmpresaID(firstCompany.id);
            this.selectedCompany = firstCompany.text;
        }

        this.initCompanyTree();

    }

    initCompanyTree(): void {
        const firstCompany = this.companyData[0]; // Ordered By ParentID in the API

        const tree = $('#company-tree').jstree({
            core: {
                data: this.companyData,
                themes: { icons: false },
                strings: { 'Loading ...': 'Cargando ...' },
            },
            plugins: ['search', 'ui'],
            search: {
                case_insensitive: true,
                show_only_matches: true
            },
            ui: {
                initially_select: [firstCompany.id]
            }
        });


        tree.on('select_node.jstree', (e: any, data: any) => {
            // HANDLE SELECT EVENT DEPENDING ON THE PARENT ORIGIN
            if (this.origin === TreeViewOrigin.Header) {
                this.selectCompanyGeneral(data.node);
            } else {
                this.selectCompanyValue(data.node);
            }
        });
    }

    searchCompany(searchString: string): void {
        $('#company-tree').jstree(true).search(searchString);
    }

    setInititalCompany(companyNode: any): any {
        $('#company-tree').jstree(true).select_node(companyNode, false, true);
    }

    selectCompanyGeneral(item: any): void {

        if (item) {
            this.setCompanyStorageData(item);
            // The following method emmits the company change
            this.empresaTreeViewService.getEmpresaID(item.id);
            this.selectedCompany = item.text;
        }

        this.resetCompanyTree();
    }

    setCompanyStorageData(company): void {       
        // this.selectedCompany = company.text;
        // localStorage.removeItem('SelectedCompanyName');
        // localStorage.setItem('SelectedCompanyName', company.text);
        // localStorage.removeItem('Empresa');
        // localStorage.setItem('Empresa', company.id);           
    }

    resetCompanyTree(): void {
        this.searchString = '';
        $('#company-tree').jstree(true).clear_search();
        $('#company-tree').jstree(true).close_all();
        this.companyTreeMenu.closeMenu();
        this.treeIcon = 'expand_more';
    }

    selectCompanyValue(item: any): void {
        if (item) {
            this.selectedCompany = item.text;
            this.companyTreeService.selectedCompany = item;
            this.companyNode.emit(item);
        }
        this.resetCompanyTree();
    }
}
